/**
 * Gas cylinder purchase price-change helpers.
 *
 * Vendor full-cylinder invoices show the real purchase / change price.
 * Empty-cylinder shell price is often omitted, so it must not block save.
 */

export const isPriceChangeEnabled = (value) => value === 1 || value === '1';

export const isBlankPrice = (value) =>
  value === '' || value === null || value === undefined;

/**
 * True when the operator entered a real empty-cylinder price (not blank/0).
 * 0 means unknown — do not invent or persist a fake shell price.
 */
export const hasKnownEmptyCylinderPrice = (value) => {
  if (isBlankPrice(value)) {
    return false;
  }

  const amount = parseFloat(value);
  return Number.isFinite(amount) && amount > 0;
};

export const normalizeOptionalCylinderPrice = (value) => {
  if (!hasKnownEmptyCylinderPrice(value)) {
    return 0;
  }

  return parseFloat(value);
};

/**
 * Split validation for vendor + full cylinder + change-price Yes.
 * Keeps gas / new purchase price required; empty cylinder price is optional.
 */
export const validateVendorFullPriceChangeSplit = (
  product,
  { fromVendor, purchaseType } = {},
) => {
  const errors = {
    price_change_empty: '',
    price_change_gas: '',
    price_sum_mismatch: '',
  };

  if (
    !isPriceChangeEnabled(product?.price_change) ||
    !fromVendor ||
    String(purchaseType) !== '0' ||
    !product?.new_price
  ) {
    return errors;
  }

  if (isBlankPrice(product.price_change_gas)) {
    errors.price_change_gas = 'Please enter Gas price';
  }

  if (
    hasKnownEmptyCylinderPrice(product.price_change_empty) &&
    !isBlankPrice(product.price_change_gas)
  ) {
    const splitTotal =
      parseFloat(product.price_change_empty) + parseFloat(product.price_change_gas);

    if (splitTotal !== parseFloat(product.new_price)) {
      errors.price_sum_mismatch =
        'The sum of empty price and gas price must be equal to the new price.';
    }
  }

  return errors;
};
